import React, { useEffect } from "react";
import logo from "../assets/Group 1.webp";
import linkedin from "../assets/linkedin.webp";
import indiamart from "../assets/indiamart.webp";
import justdial from "../assets/jd.webp";
import instagram from "../assets/insta.webp";
import facebook from "../assets/facebook.webp";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <footer className="pt-8">
      <div className="container mx-auto px-4 flex flex-col gap-6">

        <div className="flex flex-col space-y-2">
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}>
            <div className="flex items-center space-x-2">
              <img src={logo} alt="Success Logo" className="h-10 w-24" />
              <div className="flex flex-col py-6">
                <h2 className="font-bold tracking-widest font-nimbus text-2xl md:text-4xl lg:text-4xl">
                  SUCCESS
                </h2>
                <p className="font-poppins text-[#F37934] tracking-tight text-[7px] sm:text-[10px]">
                  Shipping Services (Chennai) Pvt Ltd
                </p>
              </div>
            </div>
          </Link>
          <div className="flex flex-col md:flex-row md:justify-between md:items-center mt-4 gap-4">
            <div className="flex flex-wrap font-cinzel justify-center md:justify-start space-x-4 sm:space-x-6 font-bold">
              <Link to="/">Home</Link>
              <span className="hidden sm:inline">|</span>
              <Link to="/about">About Us</Link>
              <span className="hidden sm:inline">|</span>
              <Link to="/services">Services</Link>
              <span className="hidden sm:inline">|</span>
              <Link to="/gallery">Gallery</Link>
              <span className="hidden sm:inline">|</span>
              <Link to="/blogs">Blogs</Link>
              <span className="hidden sm:inline">|</span>
              <Link to="/contact">Contact Us</Link>
            </div>
            <div className="flex justify-center md:justify-end space-x-4">
              <a
                href="https://jsdl.in/DT-20HEWYFC"
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <img
                  src={justdial}
                  alt="JustDial"
                  className="w-12 h-12 object-contain"
                />
              </a>
              <a
                href="https://www.indiamart.com/success-shipping-services/"
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <img
                  src={indiamart}
                  alt="IndiaMart"
                  className="w-12 h-12 object-contain"
                />
              </a>
              <a
                href="https://www.facebook.com/share/g/1bHBkqqFDC/"
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <img
                  src={facebook}
                  alt="Facebook"
                  className="w-12 h-12 object-contain"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/sucess/"
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <img
                  src={linkedin}
                  alt="LinkedIn"
                  className="w-12 h-12 object-contain"
                />
              </a>
              <a
                href="https://www.instagram.com/success_shipping_chennai/"
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <img
                  src={instagram}
                  alt="Instagram"
                  className="w-12 h-12 object-contain"
                />
              </a>

            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#F37934] text-center font-normal py-4 mt-6">
        <p className="text-white text-sm">
          ©Success Shipping {currentYear}. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
